export const REQUEST_HEADER_STANDALONE_TOKEN: string = 'x-standalone-token'
